import axios from "axios";
import { url } from "../baseUrl";

export const NotificationStore = {
  state: {
    all: [],

    mapLoading: false,
    mapMarkers: []
  },
  mutations: {
    getAllNotification(state, data) {
      state.all = data.map(item => ({
        id: item.id,
        notification: item.description,
        userId: item.user,
        upload_details: {
          file_name: item.upload_details.file_name,
          file_type: item.upload_details.file_type,
          uploadId: item.upload_details.id
        }
      }));
    },

    loadingMap(state, loading) {
      state.mapLoading = loading;
      if (loading) {
        state.mapMarkers = [];
      }
    },

    getMarkers(state, data) {
      state.mapMarkers = data.map((item, index) => ({
        position: {
          lat: Number(item.latitude),
          lng: Number(item.longitude)
        },
        icon: { url: "assets/images/map-marker.png" }
      }));
    }
  },
  actions: {
    getAllNotification(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/notifications/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("getAllNotification", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getMarkers(context, data) {
      context.commit("loadingMap", true);
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/enumeration/map/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("getMarkers", response.data);
            context.commit("loadingMap", false);
            resolve(response);
          })
          .catch(error => {
            context.commit("loadingMap", false);
            reject(error);
          });
      });
    }
  }
};
